export const es = {
  title: 'Calendario',
  subtitle: 'Vista unificada del calendario',
  toolbar: {
    views: {
      month: 'Mes',
      week: 'Semana',
      day: 'Dia',
    },
    today: 'Hoy',
    previous: 'Anterior',
    next: 'Siguiente',
    allFacilities: 'Todas las Instalaciones',
  },
  sidebar: {
    layers: 'Capas',
    colorMode: 'Modo de Color',
    status: 'Estado',
    retry: 'Reintentar',
    moduleError: 'Error al cargar datos del modulo',
    modules: {
      trade: 'Comercio',
      transportation: 'Transporte',
      production: 'Produccion',
      compliance: 'Cumplimiento',
      finance: 'Finanzas',
      inventory: 'Inventario',
    },
    colorModes: {
      byModule: 'Por Modulo',
      byEntityType: 'Por Tipo de Entidad',
      byStatus: 'Por Estado',
    },
  },
  popover: {
    viewDetails: 'Ver detalles',
    facility: 'Instalacion',
    status: 'Estado',
    source: 'Origen',
  },
  sources: {
    booking: 'Reserva',
    load: 'Carga',
    salesOrder: 'Orden de Venta',
    route: 'Ruta',
    driverCertification: 'Certificacion de Conductor',
    workOrder: 'Orden de Trabajo',
    inboundTolling: 'Maquila Entrante',
    outboundTolling: 'Maquila Saliente',
    dispatchRecord: 'Registro de Despacho',
    invoice: 'Factura',
    bill: 'Cuenta',
    inventoryMovement: 'Movimiento de Inventario',
  },
  emptyState: {
    noLayers: {
      title: 'No hay capas del calendario habilitadas',
      description:
        'Habilite las capas de modulos en la barra lateral para ver eventos.',
    },
    noEvents: {
      title: 'No se encontraron eventos',
      description: 'No se encontraron eventos en este rango de fechas.',
    },
    noAccess: {
      title: 'Sin acceso',
      description: 'No tiene acceso a ninguna instalacion.',
    },
  },
};
